"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function index(props) {
  var thirdList = props.thirdList,
    backgroundThirdImage = props.backgroundThirdImage;
  var backgroundThirdImageUrl = (0, _utils.fomateFileData)(backgroundThirdImage).url;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-related-class-name-audio'
  }, thirdList === null || thirdList === void 0 ? void 0 : thirdList.map(function (item, index) {
    var title = item.title,
      content = item.content,
      leftImgUrl = item.leftImgUrl,
      href = item.href,
      extendProps = item.extendProps;
    var _a = (0, _utils.fomateFileData)(leftImgUrl),
      formatLeftImgUrl = _a.url,
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-default-text-article',
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-text-article-container',
      style: {
        background: backgroundThirdImageUrl
      }
    }, /*#__PURE__*/_react["default"].createElement("a", __assign({
      className: 'flex-default-article',
      href: href
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("section", {
      className: 'flex-related-class'
    }, formatLeftImgUrl && (/*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-related-image-class'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: formatLeftImgUrl,
      alt: alt
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-related-class-right'
    }, /*#__PURE__*/_react["default"].createElement("strong", {
      style: content ? {} : {
        marginTop: '16px'
      }
    }, title), content && /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-related-div-content'
    }, content))))));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-default-related-mobile"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-default-related-slider"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-default-related-slider-inner"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-default-related-slider-scroll"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "flex-default-related-slider-list"
  }, thirdList === null || thirdList === void 0 ? void 0 : thirdList.map(function (item, index) {
    var title = item.title,
      content = item.content,
      leftImgUrl = item.leftImgUrl,
      href = item.href,
      extendProps = item.extendProps;
    var _a = (0, _utils.fomateFileData)(leftImgUrl),
      formatLeftImgUrl = _a.url,
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b;
    return /*#__PURE__*/_react["default"].createElement("a", __assign({
      className: "slider-list-li",
      style: {
        background: backgroundThirdImage
      },
      key: index,
      href: href
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("div", {
      className: "slider-list-item"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "slider-item-img"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: formatLeftImgUrl,
      alt: alt
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: "slider-item-content"
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      style: content ? {} : {
        marginTop: '16px'
      }
    }, title), /*#__PURE__*/_react["default"].createElement("div", {
      className: "slider-item-desc"
    }, content))));
  })))))));
}